/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ats_Tip_Work_BulletsInputs */

const en_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} work entries need 3+ bullet points for ATS keyword scanning`)
};

const de_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Berufserfahrungen benötigen 3+ Stichpunkte für die ATS-Keyword-Analyse`)
};

const fr_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} expériences professionnelles nécessitent 3+ puces pour l'analyse de mots-clés ATS`)
};

const es_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} entradas de trabajo necesitan 3+ viñetas para el escaneo de palabras clave ATS`)
};

const it_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} esperienze lavorative necessitano di 3+ punti elenco per la scansione delle parole chiave ATS`)
};

const nl_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} werkervaringen hebben 3+ opsommingstekens nodig voor ATS-zoekwoordscanning`)
};

const pl_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wpisów o doświadczeniu wymaga 3+ punktów do skanowania słów kluczowych ATS`)
};

const fi_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} työkokemusta tarvitsevat 3+ luettelokohtaa ATS-avainsanaskannaukseen`)
};

const da_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} arbejdserfaringer mangler 3+ punkter til ATS-søgeordsscanning`)
};

const sv_ats_tip_work_bullets = /** @type {(inputs: Ats_Tip_Work_BulletsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} arbetserfarenheter behöver 3+ punkter för ATS-nyckelordsskanning`)
};

/**
* | output |
* | --- |
* | "{count} work entries need 3+ bullet points for ATS keyword scanning" |
*
* @param {Ats_Tip_Work_BulletsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_work_bullets = /** @type {((inputs: Ats_Tip_Work_BulletsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Work_BulletsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_work_bullets(inputs)
	if (locale === "fr") return fr_ats_tip_work_bullets(inputs)
	if (locale === "es") return es_ats_tip_work_bullets(inputs)
	if (locale === "it") return it_ats_tip_work_bullets(inputs)
	if (locale === "nl") return nl_ats_tip_work_bullets(inputs)
	if (locale === "pl") return pl_ats_tip_work_bullets(inputs)
	if (locale === "fi") return fi_ats_tip_work_bullets(inputs)
	if (locale === "da") return da_ats_tip_work_bullets(inputs)
	if (locale === "sv") return sv_ats_tip_work_bullets(inputs)
	return en_ats_tip_work_bullets(inputs)
});